module.exports = __webpack_public_path__ + "img/cnx.0093ccf7.svg";